import { render, staticRenderFns } from "./SimulationPanel.vue?vue&type=template&id=2de2948e&scoped=true&"
import script from "./SimulationPanel.vue?vue&type=script&lang=js&"
export * from "./SimulationPanel.vue?vue&type=script&lang=js&"
import style0 from "./SimulationPanel.vue?vue&type=style&index=0&id=2de2948e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de2948e",
  null
  
)

export default component.exports